import {connect} from 'react-redux';

import {ConversationActionContextsEnum} from '../../../../../../libs/shared/core/src/models/api/conversationCommonTypes';
import {
  InterfaceEventsEnum,
  SnoozeLocationsEnum,
  trackInterfaceEvent,
} from '../../../../../../libs/shared/core/src/services/tracking/tracking';
import {CellsContext} from '../../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ReminderModel} from '../../../../../models/api/reminderModel';
import {setConversationsReminderAction} from '../../../../../store/data/conversations/reminderConversationsActions';
import {BasicViewerResnooze} from './basicViewerResnooze';

/*
 * Props.
 */

interface BasicViewerResnoozeContainerProps {
  canceledReminder?: ReminderModel;
  conversationId: number;
  conversationActionContext: ConversationActionContextsEnum;
  cellsContext: CellsContext;
}

/*
 * Redux.
 */

export const BasicViewerResnoozeContainer = connect(
  null,
  {setConversationsReminderAction},
  (_stateProps, dispatchProps, ownProps: BasicViewerResnoozeContainerProps) => {
    const {canceledReminder, conversationId, cellsContext, conversationActionContext} = ownProps;

    // Build the action to snooze the conversation.
    const onResnoozeClick: () => void = () => {
      if (!canceledReminder) {
        return;
      }

      dispatchProps.setConversationsReminderAction(
        cellsContext,
        [conversationId],
        canceledReminder.remindAt,
        () => conversationActionContext,
      );
      trackInterfaceEvent(InterfaceEventsEnum.SNOOZE_CONVERSATION, {
        location: SnoozeLocationsEnum.ACTIVITY_LINE,
        expiration_timestamp: canceledReminder.remindAt,
        time_option: 'Snooze again',
      });
    };

    return {
      ...ownProps,
      onResnoozeClick,
    };
  },
)(BasicViewerResnooze);
